import { combineReducers } from 'redux';

import customer from './customer';
import projects from './projects';
import scheduling from './scheduling';
import schedulingPrint from './schedulingPrint';
import snackbar from './snackbar';

export default combineReducers({
  customer,
  projects,
  scheduling,
  schedulingPrint,
  snackbar,
});
